import { boot } from 'quasar/wrappers'
import { SyncDatabase } from '../synchronizations/sync'
import { useUserStore } from '../store/useUserStore'
import { useTimesheets } from '../store/timesheets'
import { useAutoSync } from '../composables/useAutoSync'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async (/* { app, router, ... } */) => {
  useAutoSync()
  // something to do
  //attempt sync first
  const { sync } = SyncDatabase()

  //exit boot sync if rep is not logged in
  const user = useUserStore()
  if (!user.isLoggedIn) return void 0
  //or if rep needs to finish a time card
  const timesheets = useTimesheets()
  if (timesheets.hasIncompleteTimecard) return void 0
  //otherwise start sync
  setTimeout(async () => {
    await sync()
  })
})
